<template>
    <div class="businessSegment">
        <div class="indexContainer businessSegmentMain">
            <el-divider class="indexTitle">
                <div class="indexTitleMain">
                    <h3 v-show="val.languageId == 1">神谷集团业务板块</h3><br/>
                    <h4>Group Business Segment</h4>
                </div>
            </el-divider>
            <div class="businessBanner">
                <el-row>
                    <el-col :span="10" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[0].linkUrl)">
                            <div class="text">
                                <h3>{{businessList[0].title}}</h3>
                                <p>{{businessList[0].content}}</p>
                            </div>
                            <div class="pic">
                                <img :src="businessList[0].imgUrl" alt="">
                            </div>
                        </a>
                    </el-col>
                    <el-col :span="10" :offset="4" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[1].linkUrl)" style="width:100%">
                            <div class="pic">
                                <img :src="businessList[1].imgUrl" alt="">
                            </div>
                            <div class="text" style="float:right;" >
                                <h3>{{businessList[1].title}}</h3>
                                <p>{{businessList[1].content}}</p>
                            </div>
                        </a>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[2].linkUrl)">
                            <div class="text">
                                <h3>{{businessList[2].title}}</h3>
                                <p>{{businessList[2].content}}</p>
                            </div>
                            <div class="pic">
                                <img :src="businessList[2].imgUrl" alt="">
                            </div>
                        </a>
                    </el-col>
                    <el-col :span="10" :offset="4" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[3].linkUrl)" style="width:100%">
                            <div class="pic">
                                <img :src="businessList[3].imgUrl" alt="">
                            </div>
                            <div class="text" style="float:right">
                                <h3>{{businessList[3].title}}</h3>
                                <p>{{businessList[3].content}}</p>
                            </div>
                        </a>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[4].linkUrl)">
                            <div class="text">
                                <h3>{{businessList[4].title}}</h3>
                                <p>{{businessList[4].content}}</p>
                            </div>
                            <div class="pic">
                                <img :src="businessList[4].imgUrl" alt="">
                            </div>
                        </a>
                    </el-col>
                    <el-col :span="10" :offset="4" class="main">
                        <a href="javascript:void(0);" @click="handleClick(businessList[5].linkUrl)" style="width:100%">
                            <div class="pic">
                                <img :src="businessList[5].imgUrl" alt="">
                            </div>
                            <div class="text" style="float:right">
                                <h3>{{businessList[5].title}}</h3>
                                <p>{{businessList[5].content}}</p>
                            </div>
                        </a>
                    </el-col>
                </el-row>
            </div>
            <div class="phoneBanner">
                <el-row :gutter="20">
                    <el-col :span="12" v-for="(item,index) in businessList" :key="index">
                        <div class="newList2">
                            <div class="newListImg">
                                <img :src="item.imgUrl" :alt="item.imgAlt">
                            </div>
                            <p class="title">
                                <span>{{item.title}}</span>
                            </p>
                            <p class="newText" v-if="item.content">{{item.content}}</p>
                            <div>
                                <el-button size="small" plain @click="handleClick(item.linkUrl)">→ 点击进入</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
  data(){
        return{
            businessList:[]
        }
    },
    created() {
      this.businessList = this.val.attaches;
    },
    methods: {
      handleClick(linkUrl) {
          if(linkUrl){
            window.open(linkUrl, '_self');
          }
      }
    },
    watch: {
      val(val) {
        this.businessList = this.val.attaches;
      }
    }
}

</script>
<style lang="less" scoped>
.businessSegment{
    .businessBanner{
        display: none;
    }
    .phoneBanner{
        display: block;
        .newList2{
            border-radius: 4px;
            background: #f7f7f7;
            display: inline-block;
            width: 100%;
            overflow: hidden;
            margin-bottom: 10px;
            padding-bottom: 20px;
            position: relative;
            .newListImg{
                overflow: hidden;
                height: 125px;
                img{
                    height: 100%;
                    width: 100%;
                    display: block;
                }
            }
            .newListImg{
                img:hover{
                    transform: scale(1.2);
                    transition: all 3s;
                }
            }
            p.title{
                padding: 15px 10px;
                line-height: 18px;
                margin: 0;
                overflow: hidden; /*隐藏*/
                white-space: nowrap;  /*不换行*/
                text-overflow: ellipsis;  /* 超出部分省略号 */
                width: 100%;
                box-sizing: border-box;
                span{
                    color: #d11a2e;
                    font-size: 16px;
                }
            }
            p.newText{
                text-align:left;
                font-size: 14px;
                line-height: 28px;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                margin: 0 10px 10px;
                padding: 0;
                height: 56px;
                overflow: hidden;
            }
            .el-button{
                margin-top:8px;
            }
            .el-button:hover{
                border:1px solid #d11a2e;
                color: #d11a2e;
            }
            .el-button:focus{
                color: #d11a2e;
                border-color: #d11a2e;
                background-color: #f7f7f7;
            }
            .WX{
                position: absolute;
                right:10px;
                bottom: 10px;
                display: inline-block;
                // display: flex;
                vertical-align: middle;
                text-align: center;
                font-size: 14px;
                img{
                    width: 65px;
                    margin: 0 auto;
                }
                p{
                    margin: 0;
                }
            }
        }
    }
    @media only screen and (min-width: 768px){
        .businessBanner{
            display: block;
            padding: 0 10px 0;
            margin-top: 50px;
            width: 100%;
            background-image: url('./../../assets/GroupBg.jpg');
            background-repeat: no-repeat;
            background-position: center;
            height: 420px;
            .main{
                padding-top: 30px;
                .text{
                    width:65%;
                    text-align: left;
                    display: inline-block;
                    float: left;
                    h3{
                        color:#d11a2e;
                        font-size: 18px;
                        margin: 10px 0;
                    }
                }
                .pic{
                    display: inline-block;
                    flex: 1;
                    width: 80px;
                    height: 80px;
                    cursor: pointer;
                    // border: 1px solid rgba(0, 0, 0, .5);
                    box-shadow: 0 0 8px rgba(0,0,0,.2);;
                    border-radius: 80px;
                    padding: 5px;
                    overflow: hidden;
                    img{
                        display: block;
                        border-radius: 80px;
                        overflow: hidden;
                        height: 100%;
                        width: 100%;
                    }
                }
            }
            .main:hover {
                .text p{
                    text-decoration: underline;
                }
                .pic{
                    transform: scale(1.2);
                    transition: all .5s;
                }
            }
            .el-row:nth-child(2) {
                .el-col:nth-child(2){
                    padding-left: 5%;
                }
                .main{
                    padding-top: 30px;
                    padding-right: 30px;
                    .text{
                        width: 50%;
                    }
                }
            }
        }
        .phoneBanner{
            display: none;
        }
    }

}
</style>




// WEBPACK FOOTER //
// src/components/item/patch29.vue